import styled from 'styled-components';
import { getSpace, mq, px2rem, getTextType } from '../../../stylesheets/tools';

const StyledBreadcrumb = styled.nav`
  margin: 0 0;
  transform: rotate(90deg);
  transform-origin: bottom left;
  position: absolute;
  top: ${px2rem('50px')};
  left: 0;
  z-index: 1;
  display: none;

  ${mq('xl')} {
    display: block;
  }

  @media print {
    display: none;
  }

  .skeleton {
    height: 12px;
    width: 300px;
    background: linear-gradient(to right, #ececec, transparent);
    margin: calc(1em + 4px) 0;
    animation: opacityLoading 1.5s linear infinite alternate;
  }

  .breadcrumb__wrapper {
    display: flex;
    transform: rotate(180deg);
    list-style-type: none;
    margin: ${getSpace('s')} 0;

    li {
      border-left: 1px solid black;

      &:first-of-type,
      &:last-of-type {
        border-left: none;
      }
    }
  }

  .breadcrumb__link {
    ${getTextType('copy', 'international')}
    line-height: 1;
    position: relative;
    padding: 0 10px;
    cursor: pointer;
  }

  .breadcrumb__back {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    position: relative;
    margin-left: 20px;
    cursor: pointer;

    &:before {
      position: absolute;
      content: '';
      top: 50%;
      left: -20px;
      width: 10px;
      height: 10px;
      border: 1px solid black;
      border-radius: 10px;
      transform: translateY(-50%);
    }

    svg {
      height: 15px;
      margin-left: 5px;
      margin-bottom: 2px;
    }

    &:hover {
      color: ${props => props.theme.globalTheme.primary};

      svg {
        transform: translateY(-3px);
      }
    }
  }
`;

export default StyledBreadcrumb;
